<template lang="pug">
	.horizontal-scroll.bar-container(:style="{width: scrollWidth + 'vw'}" :id='id')
		.bar-section(v-for="(bar, cnt) in chartBars.barGroups" :key='cnt' :style="{width: barSectionWidth(bar) + 'vw', border: '0px solid red'}")
			.bar-graph-container(:style="{ height: (100 - tickScale) + '%' }" v-if="barType=='stacked'")
				.bar-iterations.stacked(v-for="(barValue, bi) in bar.barValues" :key="bi" :style="{width: barIterationsWidth + 'vw', height: (100 - tickScale) + '%' , border: '0px solid blue'}")                
					.bar-value.stacked(:style="{width: bar.barMargin+'vw', color: bar.barColors[bi], left: 0 + 'vw', top: calcTxtTop(bar.barValues, bi) + '%'}") {{ formatNumberReal(bar.barValues[bi]) }}
					.bar-itself.stacked(:style="{width: width + 'vw', backgroundColor: bar.barColors[bi], height: (100 - barScale) * bar.barValues[bi]/maxScale + '%', top: calcTop(bar.barValues, bi) + '%', left: (1.5 + parseFloat(margin)) + 'vw'}")
			.bar-graph-container(:style="{ height: (100 - tickScale) + '%', }" v-else)
				.bar-iterations(v-for="(barValue, bi) in bar.barValues" :key="bi" :style="{width: barIterationsWidth + 'vw', height: '100%', float: 'left', border: '0px solid blue'}")
					.bar-value(:style="{width: barIterationsWidth + 'vw', color: bar.barColors[bi], bottom: (tickScale*6) +'%', left: barValuePosition(bar, bi) + 'vw'}") {{ barString(bar, bi) }}
					.bar-itself(:style="{width: width + 'vw', backgroundColor: bar.barColors[bi], height: (100 - barScale) * bar.barValues[bi]/maxScale + '%', top: calcTop(bar.barValues, bi) + '%', left: margin + 'vw'}")
			.bar-label(:style="{height: tickScale + '%', color: bar.barColor}") {{ bar.barLabel }}
</template>

<script>

import formatNumberReal from '@/lib/utils/formatNumberReal';

export default {
	name       : 'chartBody',
	components : { formatNumberReal },
	props : {
		id: {
			type: String,
		},
		tickScale: {
			type: Number,
		},
		barScale: {
			type: Number,
		},
		chartBars: {
			type: Object,
		},
		barDims: {
			type: Object,
		},
		maxScale: {
			type: Number,
		},
		barType: {
			type: String,
		},
	},
	data : () => ( {

	} ),
	computed : {
		scrollWidth() {
			// console.log('calc scrollWidth');
			// console.log(this.chartBars);
			let scrollWidth=0;
			switch(this.barType) {
				case 'stacked':
				const barcnt=this.chartBars.barGroups.length;
				scrollWidth=barcnt * (parseFloat(this.barDims.barWidth) + (this.barDims.barMargin * 2));
				break;
				default:
				const barcntd=this.chartBars.barGroups.map( obj => obj.barValues.length * ((this.barDims.barWidth*1) + (this.barDims.barGroupMargin * 2)));
				const bartotals = barcntd.reduce((a, b) => a + b, 0);
				// console.log(`barTotals: ${bartotals}`);
				// console.log(barcntd);

				scrollWidth=((this.barDims.barMargin * 2) * (barcntd.length * 1)) + parseFloat(bartotals) + 5;
				break;
			}

			// console.log(`scrollWidth: ${scrollWidth}`);
			return scrollWidth;
		},
		margin() {
			return this.barDims.barMargin;
		},
		width() {
			return this.barDims.barWidth;
		},
		barIterationsWidth() {
			// console.log('barIterationsWidth');
			const barIterationsWidth = (parseFloat(this.barDims.barWidth) + (parseFloat(this.barDims.barGroupMargin) * 2) );
			// console.log(`barIterationsWidth: ${barIterationsWidth}`);
			return barIterationsWidth;
		},
	},

	methods : {
		calcTxtTop(bar, i) {
			/*
			let val = this.calcTop(bar, i);//eslint-disable-line

			// console.log(bar);
			let lval=0;
			let ldiff=0;
			if(i>0) {
				lval=this.calcTxtTop(bar, (i-1));
				ldiff=lval-val;
			}
			if(ldiff<this.barScale) {
				// console.log(`changeVal: ${val} - ${this.barScale}`);
				val-=this.barScale;
			}
			const data={
				i,
				val,
				lval,
				ldiff
			};
			// console.log(data);
			// console.log(`calcTxtTop: ${i} - ${val} => ${lval} : ${ldiff}`);
			
			//*/
			const val = (6 - i - 1) * this.barScale;

			return val;
		},
		calcTop(bar, i) {
			// console.log(`i ${i}`);
			// console.log(bar);
			// console.log(`barScale: ${this.barScale}`);
			switch(this.barType) {
				case 'stacked':
				let barAdd = 0;
				for(let li = 0; li < bar.length; li++) {
					if(li <= i) {
						barAdd += bar[li];
					}
				}
				return (100-(100 - this.barScale) * (barAdd/this.maxScale));
				// return (totalBarPercent*100);
				default:
				return (100-(100 - this.barScale) * (bar[i]/this.maxScale));
			}
		},
		formatNumberReal(val) {
			// console.log(`formatNumberReal: ${val}`);
			return formatNumberReal(val);
		},
		barSectionWidth(barSection) {
			switch (this.barType) {
				case 'stacked':
				return (this.width * 1) + (this.barDims.barMargin * 2);
				default:
				return (((this.barDims.barGroupMargin * 2) + (this.width * 1)) * barSection.barValues.length) + (this.barDims.barMargin * 2);
			}
		},
		barValueWidth(bar) {
			const barValueWidth = (100 / bar.barValues.length);
			// console.log(`barValueWidth: ${barValueWidth}`);
			return barValueWidth;
		},
		barValuePosition(v, i) {
			const barWidth = (this.barDims.barWidth*1) + (this.barDims.barGroupMargin * 2);
			const barValuePosition = (this.margin * 1) + (barWidth * i);
			return barValuePosition;
		},
		barString(bar, bi) {
			/* {{ formatNumberReal(bar.barValues[bi]) }} {{ (bar.barSuffixs && bi in bar.barSuffixs) ? bar.barSuffixs[bi] : '' }} */
			let barString = `${formatNumberReal(bar.barValues[bi])} ${(bar.barSuffixs && bi in bar.barSuffixs) ? bar.barSuffixs[bi] : ''}`;
			if('barString' in bar) {
				barString = `${bar.barString[bi]}`;
			}
			return barString;
		}
	},
	created() {
		// console.log('created chartBody');
		// console.log(`BarType: ${this.barType}`);
		// console.log(this.tickScale);
		// console.log(this.chartBars);
		// console.log('barDims');
		// console.log(this.barDims);
		// console.log(((this.margin*2) + (this.width*1))); //eslint-disable-line
		// console.log(`Max Val: ${this.maxScale}`);
		// console.log(1440000/2400000);

		// console.log(`tickScale ${this.tickScale}`);


		/*
		// console.log(this.entitySummaryData);
		// console.log(this.fieldSummaryData);
		// console.log(this.varietySummaryData);
		// console.log(this.paymentScheduleData);
		// console.log(this.yearsAvailable);
		*/
		this.$emit('loaded', this.id);
	},

	mounted() {
	},

	watch : {
	},

};
</script>

<style lang="scss" scoped>
._horizontal-scroll {
	box-sizing: border-box;
	overflow-x: scroll;
	overflow-y: hidden;
}
.bar-container {
	width: 95%;
	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: none;
	}
	.bar-section {
		float: left;
		position: relative;
		height: 100%;
		.bar-graph-container {
			.bar-iterations {
				&.stacked {
					position:absolute;
				}
				.bar-value {
					font-size: 2vmin;
					position: absolute;
					text-shadow: .06vmin .06vmin #026A44;
					&.stacked {
						left: -8.5vw;
						border-radius:2vh;
						text-shadow: .1vmin .1vmin #026A44;
						z-index: 1000;
					}
				}
			}
		}
		.bar-label {
			font-size: 2vmin;
		}
			.bar-itself {
				position: relative;
				border-radius: 5% 5% 0 0;
				color: black;
				background-color: black;
				&.stacked {
					border-radius: 5% 5% 5% 5%;
					position:absolute;
				}
			}
		
	}
}
</style>
